module.exports = __webpack_public_path__ + "img/spain.42f8daf1.png";